import { NavLink } from "react-router"
import styles from "./tab-bar.module.css"

const tabs = [
  { path: "/discovery", label: "发现", icon: "🔍" },
  { path: "/growth", label: "成长", icon: "📚" },
  { path: "/tasks", label: "任务", icon: "📋" },
  { path: "/me", label: "我的", icon: "👤" },
]

export function TabBar() {
  return (
    <nav className={styles.tabBar}>
      {tabs.map((tab) => (
        <NavLink
          key={tab.path}
          to={tab.path}
          className={({ isActive }) =>
            `${styles.tab} ${isActive ? styles.active : ""}`
          }
        >
          <span className={styles.icon}>{tab.icon}</span>
          <span className={styles.label}>{tab.label}</span>
        </NavLink>
      ))}
    </nav>
  )
}